export const APP_INFO = {
  TITLE: 'CongressMCP',
  DESCRIPTION: 'Free, open-source MCP server for congressional data',
  VERSION: '2.0.0',
  AUTHOR: 'Alex Murshak',
}

export const EXTERNAL_LINKS = {
  GITHUB: 'https://github.com/amurshak/congressMCP',
  GITHUB_ISSUES: 'https://github.com/amurshak/congressMCP/issues',
  PYPI: 'https://pypi.org/project/congressmcp/',
  CONGRESS_API: 'https://api.congress.gov',
  CONGRESS_API_SIGNUP: 'https://api.congress.gov/sign-up/',
  MCP_DOCS: 'https://modelcontextprotocol.io',
  UV_DOCS: 'https://docs.astral.sh/uv/',
}

export const ROUTES = {
  HOME: '/',
  SETUP: '/setup',
  TERMS: '/terms',
  PRIVACY: '/privacy',
}

export default {
  APP_INFO,
  EXTERNAL_LINKS,
  ROUTES,
}
